export default [
  { id: 1, label: "Número de Telefone" },
  { id: 2, label: "CNJ" },
  { id: 3, label: "CNCIA" },
  { id: 4, label: "CEIS" },
  { id: 5, label: "CNEP" },
  { id: 6, label: "CEPIM" },
  { id: 7, label: "CGU-PJ" },
  { id: 8, label: "ePAD" },
  { id: 9, label: "CGU-PAD" },
  { id: 10, label: "TCU" },
  { id: 11, label: "Outras Certidões - TCU" },
  { id: 12, label: "CNES/CNS" },
  { id: 13, label: "CNR BAURU" },
  { id: 14, label: "Inscrição no Cadastro de Contribuinte Municipal GMS" },
  { id: 15, label: "Cancelamento de NF" },
];